module.exports = __webpack_public_path__ + "static/media/sort-ascend.8ad5cb23.svg";